const config = {
    components: {
        block: {
            unmountClose: true,
        },
    },
    modules: {
        home: {
            enable: true,
        },
        report: {
            enable: true,
        },
        linkages: {
            enable: true,
        },
        monitoring: {
            enable: true,
        },
        distraints: {
            enable: true,
        },
        portfolio: {
            enable: true,
            toolbar: {
                components: ['navigation', 'exports'],
            },
            workspace: {
                lazyRender: true,
                simulateChildComponents: true,
            },
        },
    },
}

module.exports = config
